// extracted by mini-css-extract-plugin
export default {"container":"OrganizationProfileTab_container__dyvpZ","table":"OrganizationProfileTab_table__IUBX-","tableCol":"OrganizationProfileTab_tableCol__eMdUJ"};